import AllActions from "@/infrastructure/rootAction";

import produce from "immer";
import { getType } from "typesafe-actions";

import * as A from "./actions";
import { defaultState } from "./defaults";

export default (state = defaultState, action: AllActions) =>
  produce(state, draft => {
    switch (action.type) {
      case getType(A.fetchDashboardMeta.request):
        draft.status.meta = "REQUEST";
        break;
      case getType(A.fetchDashboardMeta.failure):
        draft.status.meta = "FAILURE";
        break;
      case getType(A.fetchDashboardMeta.success):
        draft.status.meta = "SUCCESS";
        draft.meta = action.payload;
        break;

      case getType(A.fetchBenchmarkAnalysis.request):
        draft.status.benchmark = "REQUEST";
        break;
      case getType(A.fetchBenchmarkAnalysis.failure):
        draft.status.benchmark = "FAILURE";
        break;
      case getType(A.fetchBenchmarkAnalysis.success):
        draft.status.benchmark = "SUCCESS";
        draft.benchmark = {
          ...state.benchmark,
          [action.payload.exchange]: action.payload.data
        };
        break;

      case getType(A.fetchSectorIndustryPerf.request):
        draft.status.performance = "REQUEST";
        break;
      case getType(A.fetchSectorIndustryPerf.failure):
        draft.status.performance = "FAILURE";
        break;
      case getType(A.fetchSectorIndustryPerf.success):
        draft.status.performance = "SUCCESS";
        draft.performance = action.payload;
        break;
    }
  });
